<template>
  <div id="mainFrame">
    <v-row id="headerRow">
      <h1>Willkommen, {{ firstName }}!</h1>
      <v-spacer />
      <div id="clientSelect">
        <v-select
          :disabled="userClients.length <= 1"
          v-model="currentClient"
          :items="userClients"
          item-text="companyName"
          item-value="id"
          label="Aktueller Mandant"
        ></v-select>
      </div>
    </v-row>
    <v-row class="row1">
      <v-col>
        <v-card id="processCard">
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-subtitle>Erstelle ein Modell und erfasse basierend darauf die Process Experience.</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-spacer></v-spacer>
        <v-card-actions id="cardActions">
          <v-btn color="primary" @click="showCreateDialog = !showCreateDialog">Modell erstellen</v-btn>
        </v-card-actions>
        <NewProcessDialog v-model="showCreateDialog" />
      </v-card>
    </v-col>
    <v-col>
      <v-card id="processCard">
      <v-list-item three-line>
        <v-list-item-content>
          <v-list-item-subtitle>Importiere ein Modell und erfasse basierend darauf die Process Experience.</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-card-actions id="cardActions">
        <v-btn color="primary" id="cardButton" @click="showImportDialog = !showImportDialog">Modell importieren</v-btn>
      </v-card-actions>
      <ImportProcessDialog v-model="showImportDialog" />
    </v-card>
    </v-col>
    </v-row>
    <v-row class="row2">
      <v-col>
        <v-card id="surveyCard">
          <v-card-title>Umfragen</v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <LoadingOverlay :dialog="newClientLoading"/>
  </div>
</template>

<script>
import NewProcessDialog from "./NewProcessDialog";
import ImportProcessDialog from "./ImportProcessDialog";
import LoadingOverlay from '../../components/common/LoadingOverlay.vue';
import clientService from "@/components/clientService"

export default {
  components: {
    NewProcessDialog,
    ImportProcessDialog,
    LoadingOverlay,
  },
  data: () => ({
    showImportDialog: false,
    showCreateDialog: false,
    newClientLoading: false
  }),
  computed:{
    firstName(){
      return this.$store.state.currentUser.firstName;
    },
    userClients(){
      return this.$store.state.currentUser.clients;
    },
    currentClient: {
      get() {
        let currentClientId = this.$store.state.currentUser.currentClientId;
        return this.$store.state.currentUser.clients.filter(elem => elem.id == currentClientId)[0];
      },
      async set(value) {
        this.newClientLoading = true;
        await this.$store.dispatch("changeCurrentClient", value);
        this.newClientLoading = false;
        window.location.reload(); 
        
      }
    }
  }
};
</script>
<style scoped>
#clientSelect{
  width:25%;
  float:right;
}
#headerRow{
  margin: 0px 8px;
}
.dashboardFrame{
  height:95%
}
#processCard{
  background-color: #F5F5F5;
  height: 100%;
}
#surveyCard{
  width:100%;
  background-color: #F5F5F5;
  height: 97.5%;
}
.row1{
  height:40%;
  margin: 2.5% 0;
}
.row2{
  height:45%;
  margin: 2.5% 0;
}
#cardActions{
  position: absolute;
  right: 0;
  bottom: 0;
}
</style>